<template>
  <vs-popup
    class="mt4-info-dialog"
    :title="title"
    :active.sync="dialogShow"
  >
    <div class="down-top">
      <div
        v-for="(item,index) in accountMapArr"
        :key="index"
        class="line-box line-flex-row">
        <div class="lin-left">{{item.label}}</div>
        <div class="line-el"></div>
        <span class="data-span">{{item.data}}</span>
        <i
          v-if="index <= 2"
          class="iconfont icon-copy1 pointer"
          @click="copyHandle(item.data)"
        ></i>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import copy from 'copy-to-clipboard';
import { getAccountType } from "@/utils/common";
export default {
  name: "Mt4InfoDialog",
  props: {
    accountInfo: {
      type: Object,
      default(){
        return {
          login: '',
        }
      }
    },
  },
  data() {
    let _this = this;
    return {
      dialogShow: false,
      title: _this.$t('account_information'),
    }
  },
  computed: {
    accountMapArr() {
      // 没有服务器字段 需重新联调 todo
      let arr = [
        { label: this.$t('Trading_System'),data: 'MT4' },
        { label: this.$t('transaction_account'),data: this.accountInfo.login },
        { label: this.$t('server'),data: this.accountInfo.serverName },
        { label: this.$t('Home.accountType'),data: this.accountInfo.accType },
        { label: this.$t('User.leverage'),data: `1:${this.accountInfo.leverage}`},
      ]
      return arr;
    }
  },
  methods: {
    copyHandle(data) {
      copy(data);
      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess'),
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.mt4-info-dialog {
  .down-top {
    margin-bottom: 30px;
  }
  .line-box {
    margin-bottom: 10px;
    font-size: 14px;
    .lin-left {
      color: #A29FAE;
    }
    .data-span {
      margin-right: 10px;
    }
  }
}
</style>
